import Main from './components/Main'
import Error from "./components/NotFound"
import HomeLayout from './Layouts/HomeLayout'
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route } from "react-router-dom";

function App() {

  const router = createBrowserRouter(createRoutesFromElements(
    <Route path="/" element={<HomeLayout />} errorElement={<Error />}>
      <Route index element={<Main />}/>
      <Route path="*" element={<Error />} />
    </Route>
    )
  )
  return (
    <RouterProvider router={router} />
  )
}

export default App
